// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"b08a45a0","453":"b497483a","930":"d207e149"}[chunkId] + ".chunk.js";
};